import { Outlet } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography } from '@mui/material';

function DashboardLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflow: 'hidden' }}>
      {/* Header */}
      <AppBar
        position="fixed"
        sx={{
          bgcolor: '#003087',
          top: 0,
          left: 0,
          right: 0
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="/logo.ico"
              alt="Logo"
              style={{ width: 32, height: 32 }}
            />
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              TDS Onboarding Service
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: '#f5f5f5',
          py: 3,
          minHeight: '100vh',
          overflow: 'auto',
          width: '100%'
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
          <Outlet />
        </Box>
      </Box>

      {/* Footer */}
      {/* <Box
        component="footer"
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          py: 2,
          px: 3,
          bgcolor: '#ffffff',
          borderTop: '1px solid #e0e0e0'
        }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          CelcomDigi E2E Automation Team
        </Typography>
      </Box> */}
    </Box>
  );
}

export default DashboardLayout;
